import { WorkExperience as WorkExperienceInterface } from '../../../../../store/workspace/types';
import { EditIcon, TrashIcon } from '../../../../../assets/icons/common';
import { useDispatch } from '../../../../../store/store';
import styles from './style.module.scss';
import {
    setAddWorkExperienceModal,
    setWorkExperienceEditMode,
    setSelectedWorkExperience,
    setDeleteWorkExperienceModal,
} from '../../../../../store/workspace/slice';

interface Props {
    data: WorkExperienceInterface[] | undefined;
};

export default function WorkExperience(props: Props) {
    const { data } = props;
    const copyOfData = (data && Array.isArray(data)) ? [...data] : null;
    const sortByDate = copyOfData ? copyOfData.sort((a, b) => new Date(a.from).getTime() - new Date(b.from).getTime()) : null;
    const dispatch = useDispatch();

    const editExperience = (item: WorkExperienceInterface) => {
        dispatch(setWorkExperienceEditMode(true));
        dispatch(setSelectedWorkExperience(item));
        dispatch(setAddWorkExperienceModal(true));
    };

    const deleteExperience = (item: WorkExperienceInterface) => {
        dispatch(setSelectedWorkExperience(item));
        dispatch(setDeleteWorkExperienceModal(true));
    };

    return (
        <div className={styles.wrapper}>
            {data && data.length === 0 && <span>I don't have work experience.</span>}
            {sortByDate?.map((item, indx) => <div className={styles.content}>
                <div className={styles.content_headbar}>
                    <span className={styles.content_headbar_title}>Job {indx + 1}</span>
                    <div className={styles.content_headbar_actions}>
                        <EditIcon onClick={() => editExperience(item)} />
                        <TrashIcon onClick={() => deleteExperience(item)} />
                    </div>
                </div>
                <div className={styles.content_main}>
                    <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>Job title</span>
                        <span className={styles.content_main_row_val}>{item.jobTitle}</span>
                    </div>
                    <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>Company</span>
                        <span className={styles.content_main_row_val}>{item.company}</span>
                    </div>
                    <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>Location</span>
                        <span className={styles.content_main_row_val}>{item.location}</span>
                    </div>
                    <div className={styles.content_main_row} data-col-in-mobile="true">
                        <span className={styles.content_main_row_prop}>Role description</span>
                        <span className={styles.content_main_row_val}>{item.roleDescription}</span>
                    </div>
                    <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>Date</span>
                        <span className={styles.content_main_row_val}>{item.from} - {item.to}</span>
                    </div>
                </div>
            </div>)}
            <div
                className={styles.add_btn}
                onClick={() => dispatch(setAddWorkExperienceModal(true))}
            >
                <span>+ Add work experience</span>
            </div>
        </div>
    )
}
